/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["header[_ngcontent-%COMP%]{font-size:24px;color:#148900;font-weight:600;text-align:left;margin:34px 0 20px}.dashboard-cell[_ngcontent-%COMP%]{word-break:break-word;overflow-x:hidden}i[_ngcontent-%COMP%]{font-size:25px;margin:0 5px}.action-text[_ngcontent-%COMP%]{vertical-align:4px}a.start-survey[_ngcontent-%COMP%]{color:#148900;text-decoration:none}a.start-survey[_ngcontent-%COMP%]:hover{color:#107000}.ses-dashboard-row[_ngcontent-%COMP%]:first-of-type{border-top:1px solid #e5e5e5}"];
export { styles as styles };
